<div class="wm-page position-relative min-vh-100 overflow-hidden">
  <!-- Background illustration: dim mountains behind the construction scene (top-right).
       The building sketch lives in the grid. -->
  <img
    src="assets/images/welcome-mountains.png"
    class="wm-illus wm-illus--mountains position-fixed end-0 pe-none z-0"
    alt=""
    aria-hidden="true"
  />
  <img
    src="assets/images/welcomebg1-amber.svg"
    class="wm-illus wm-illus--top position-fixed pe-none z-0"
    alt=""
    aria-hidden="true"
  />

  <!-- What's New is for super admins only. -->
  @let isSuperAdmin = (user.role || '').toLowerCase().includes('superadmin');

  <!-- Pure-CSS toggle for the rail labels (hamburger). -->
  <input type="checkbox" id="wm-rail-toggle" class="wm-rail-toggle" hidden />

  <!-- Left rail (bottom tab bar on small screens) -->
  <aside
    class="wm-rail position-fixed z-3 d-flex flex-row flex-md-column align-items-center justify-content-around justify-content-md-start"
  >
    <label
      for="wm-rail-toggle"
      class="wm-rail__menu d-none d-md-flex align-items-center justify-content-center cursor-pointer"
      role="button"
      aria-label="Hide menu"
    >
      <i class="bi bi-list"></i>
    </label>

    <nav
      class="wm-rail__nav d-flex flex-row flex-md-column gap-0 gap-md-4 justify-content-around justify-content-md-start flex-fill flex-md-grow-0"
    >
      <button
        type="button"
        class="wm-rail__item d-flex flex-column align-items-center m-0 p-0 border-0 bg-transparent text-decoration-none cursor-pointer"
        [class.is-active]="viewMode === 'home'"
        [attr.aria-current]="viewMode === 'home' ? 'page' : null"
        (click)="setView('home')"
      >
        <span class="wm-rail__icon d-flex align-items-center justify-content-center"
          ><i class="bi bi-house-door-fill"></i
        ></span>
        <span class="wm-rail__label">Home</span>
      </button>
      <label
        for="wm-search-input"
        class="wm-rail__item d-flex flex-column align-items-center m-0 p-0 border-0 bg-transparent text-decoration-none cursor-pointer"
        role="button"
      >
        <span class="wm-rail__icon d-flex align-items-center justify-content-center"><i class="bi bi-search"></i></span>
        <span class="wm-rail__label">Search</span>
      </label>
      <button
        type="button"
        class="wm-rail__item d-flex flex-column align-items-center m-0 p-0 border-0 bg-transparent text-decoration-none cursor-pointer"
        [class.is-active]="viewMode === 'favorites'"
        [attr.aria-current]="viewMode === 'favorites' ? 'page' : null"
        (click)="setView('favorites')"
      >
        <span class="wm-rail__icon d-flex align-items-center justify-content-center">
          <i class="bi" [ngClass]="viewMode === 'favorites' ? 'bi-star-fill' : 'bi-star'"></i>
        </span>
        <span class="wm-rail__label">Favorites</span>
      </button>
      @for (module of availableModules; track module.route) {
        @if (module.label === 'Administration') {
          <a
            routerLink="/administration/activity-tracker"
            class="wm-rail__item d-flex flex-column align-items-center m-0 p-0 border-0 bg-transparent text-decoration-none cursor-pointer"
          >
            <span class="wm-rail__icon d-flex align-items-center justify-content-center"
              ><i class="bi bi-bar-chart-line"></i
            ></span>
            <span class="wm-rail__label">Activity</span>
          </a>
        }
      }
    </nav>
  </aside>

  <div class="wm-main position-relative z-1 min-vh-100 d-flex flex-column">
    <!-- Top bar: Cinari (product) · client brand · user menu -->
    <header class="wm-topbar position-relative d-flex align-items-center justify-content-between gap-3">
      <div class="d-flex align-items-center">
        <label
          for="wm-rail-toggle"
          class="wm-topbar__menu align-items-center justify-content-center cursor-pointer"
          role="button"
          aria-label="Show menu"
        >
          <i class="bi bi-list"></i>
        </label>
        <img src="assets/images/cinari-logo.png" class="wm-logo" alt="Cinari" />
      </div>

      <div class="d-flex align-items-center gap-3 gap-md-4">
        <img src="assets/images/logo.png" class="wm-client-logo d-none d-md-block" alt="Treasure Hill" />
        <span class="wm-topbar__divider d-none d-md-block"></span>

        <!-- <details> gives an accessible dropdown without extra JS. -->
        <details #userMenu class="wm-user position-relative">
          <summary class="position-relative d-flex align-items-center gap-2 cursor-pointer">
            <span
              class="wm-user__avatar d-flex align-items-center justify-content-center flex-shrink-0 rounded-circle fw-500 text-white"
              >{{ user.firstName.charAt(0) }}{{ user.lastName.charAt(0) }}</span
            >
            <span class="d-none d-sm-flex flex-column lh-sm">
              <span class="wm-user__name fs-16 fw-500 text-nowrap">{{ user.firstName }} {{ user.lastName }}</span>
              <span class="wm-user__role">{{ user.role }}</span>
            </span>
            <i class="bi bi-chevron-down wm-user__chevron"></i>
          </summary>
          <!-- Invisible full-screen layer behind the open menu: any outside click closes it. -->
          <div
            class="wm-user__backdrop position-fixed top-0 start-0 end-0 bottom-0"
            (click)="userMenu.removeAttribute('open')"
          ></div>
          <div class="wm-user__menu position-absolute end-0 bg-white">
            @if (isSuperAdmin) {
              <!-- New tab, so the portal stays open behind it. -->
              <a
                routerLink="/whats-new"
                target="_blank"
                rel="noopener"
                class="wm-user__menu-item w-100 d-flex align-items-center border-0 bg-transparent fs-14 text-start text-decoration-none"
                (click)="userMenu.removeAttribute('open')"
              >
                <i class="bi bi-stars"></i> What's New
              </a>
            }
            <button
              type="button"
              class="wm-user__menu-item w-100 d-flex align-items-center border-0 bg-transparent fs-14 text-start text-decoration-none"
              (click)="logout()"
            >
              <i class="bi bi-box-arrow-right"></i> Logout
            </button>
          </div>
        </details>
      </div>
    </header>

    <div class="wm-content position-relative flex-fill d-flex flex-column w-100">
      <!-- Hero: greeting + (collapsed) search -->
      <section class="wm-hero d-flex align-items-end justify-content-center justify-content-md-between flex-wrap">
        <div class="text-center text-md-start">
          <p class="wm-eyebrow mb-1 fw-500 text-uppercase">Welcome back,</p>
          <h1 class="wm-name m-0 fw-400 lh-1 text-capitalize">{{ user.firstName }}</h1>
        </div>

        <!-- Collapsed until focused (e.g. via the rail's Search) or holding a query. -->
        <label class="wm-search d-flex align-items-center gap-2 m-0" for="wm-search-input">
          <i class="bi bi-search"></i>
          <!-- (input)="0" just triggers change detection so the grid filters as you type. -->
          <input
            #search
            id="wm-search-input"
            class="flex-fill border-0 bg-transparent fs-14"
            type="text"
            placeholder="Search modules, pages…"
            aria-label="Search modules and pages"
            autocomplete="off"
            (input)="(0)"
            (keydown.escape)="search.value = ''; search.blur()"
          />
          @if (search.value) {
            <button
              type="button"
              class="wm-search__clear border-0 bg-transparent p-0"
              aria-label="Clear search"
              (click)="search.value = ''"
            >
              <i class="bi bi-x-lg"></i>
            </button>
          }
        </label>
      </section>

      @let q = search.value.trim().toLowerCase();

      <div class="wm-results">
        <div class="wm-grid">
          @for (module of displayedModules; track module.route) {
            <ng-container *ngTemplateOutlet="moduleSwitch; context: { $implicit: module, q }"></ng-container>
          }
        </div>

        <!-- Per-module card content. Links are [label, route?] pairs; a missing route falls back to the module route. -->
        <ng-template #moduleSwitch let-module let-q="q">
          @switch (module.label) {
            @case ('Accounting') {
              <ng-container
                *ngTemplateOutlet="
                  moduleCard;
                  context: {
                    $implicit: module,
                    q,
                    desc: 'Deposits, invoices and financial reports.',
                    links: [['User Setup'], ['Accounting']]
                  }
                "
              ></ng-container>
            }
            @case ('Administration') {
              <ng-container
                *ngTemplateOutlet="
                  moduleCard;
                  context: {
                    $implicit: module,
                    q,
                    desc: 'Users, permissions and audit trails.',
                    links: [
                      ['User Management', '/administration'],
                      ['Activity Tracker', '/administration/activity-tracker'],
                      ['Login Activity Report', '/administration/login-activity-report']
                    ]
                  }
                "
              ></ng-container>
            }
            @case ('Buyer Connect') {
              <ng-container
                *ngTemplateOutlet="
                  moduleCard;
                  context: {
                    $implicit: module,
                    q,
                    title: 'Buyer',
                    desc: 'Buyer profiles and portal activity.',
                    links: [['Dashboard']]
                  }
                "
              ></ng-container>
            }
            @case ('CRM') {
              <ng-container
                *ngTemplateOutlet="
                  moduleCard;
                  context: {
                    $implicit: module,
                    q,
                    external: true,
                    desc: 'Contacts, companies, deals, tickets and outreach.',
                    links: []
                  }
                "
              ></ng-container>
            }
            @case ('DSM') {
              <ng-container
                *ngTemplateOutlet="
                  moduleCard;
                  context: {
                    $implicit: module,
                    q,
                    desc: 'Decore Studio Manager - appointments and selections.',
                    links: [
                      ['Contracts', '/dsm/contracts'],
                      ['Appointments', '/dsm/appointments']
                    ]
                  }
                "
              ></ng-container>
            }
            @case ('Executive Console') {
              <ng-container
                *ngTemplateOutlet="
                  moduleCard;
                  context: {
                    $implicit: module,
                    q,
                    desc: 'Executive signature approvals and signing history.',
                    links: [['Dashboard']]
                  }
                "
              ></ng-container>
            }
            @case ('File Management') {
              <ng-container
                *ngTemplateOutlet="
                  moduleCard;
                  context: {
                    $implicit: module,
                    q,
                    desc: 'Files, folders, starred, and deleted items.',
                    links: [
                      ['All Files', '/all-files/0'],
                      ['Recent Folders', '/all-files/recent-folders'],
                      ['Deleted Files', '/all-files/deleted-files']
                    ]
                  }
                "
              ></ng-container>
            }
            @case ('Home Building') {
              <ng-container
                *ngTemplateOutlet="
                  moduleCard;
                  context: {
                    $implicit: module,
                    q,
                    desc: 'Projects, lots, products and takeoffs.',
                    links: [
                      ['Projects', '/home-building/projects/import'],
                      ['Lots', '/home-building/lots'],
                      ['Template Document', '/home-building/template-document'],
                      ['Products', '/home-building/product-catalogue/products'],
                      ['Sales Takeoff', '/home-building/sales-takeoff']
                    ]
                  }
                "
              ></ng-container>
            }
            @case ('Sales') {
              <ng-container
                *ngTemplateOutlet="
                  moduleCard;
                  context: {
                    $implicit: module,
                    q,
                    desc: 'Prospects, APS and sales calendar.',
                    links: [
                      ['APS', '/sales/aps'],
                      ['Prospects', '/sales/prospects'],
                      ['Calendar', '/sales/calendar']
                    ]
                  }
                "
              ></ng-container>
            }
            @case ('Scheduler') {
              <ng-container
                *ngTemplateOutlet="
                  moduleCard;
                  context: {
                    $implicit: module,
                    q,
                    desc: 'Tasks, project schedules and lot planning.',
                    links: [
                      ['Tasks Import', '/scheduler/tasks/import'],
                      ['Create Schedule', '/scheduler/create-schedule'],
                      ['Schedule Lots', '/scheduler/schedule-lots']
                    ]
                  }
                "
              ></ng-container>
            }
            @case ('Warranty') {
              <ng-container
                *ngTemplateOutlet="
                  moduleCard;
                  context: {
                    $implicit: module,
                    q,
                    desc: 'Work orders, warranties and categories.',
                    links: [
                      ['Work Order Management', '/warranty/work-order-management'],
                      ['Warranty Scheduler', '/warranty/warranty-scheduler'],
                      ['Categories', '/warranty/categories']
                    ]
                  }
                "
              ></ng-container>
            }
          }
        </ng-template>

        <!-- Shown by CSS when the search / favorites filter hides every card. -->
        <div class="wm-empty py-5 px-3 text-center">
          @if (viewMode === 'favorites' && !search.value.trim()) {
            <i class="bi bi-star fs-32 text-primary"></i>
            <p class="mt-2 mb-1">No favorites yet</p>
            <button type="button" class="btn btn-link p-0 fs-14" (click)="setView('home')">Browse modules</button>
          } @else {
            <i class="bi bi-search fs-32 text-primary"></i>
            <p class="mt-2 mb-1">No modules match “{{ search.value }}”</p>
            <button type="button" class="btn btn-link p-0 fs-14" (click)="search.value = ''">Clear search</button>
          }
        </div>
      </div>

      <!-- Decorative Treasure Hill building: pinned to the bottom-right of the content, behind the cards. -->
      <img
        src="assets/images/welcome-building-sketch.png"
        class="wm-building position-absolute end-0 z-n1 pe-none d-none d-lg-block"
        alt=""
        aria-hidden="true"
      />

      <footer
        class="wm-footer position-relative d-flex flex-wrap align-items-center justify-content-center align-self-center mw-100 mt-auto"
      >
        <span>© {{ Date.getFullYear() }} Treasure Hill. Celebrating 20 Years.</span>
        <span aria-hidden="true">•</span>
        <span>Powered by <strong>Cinari</strong></span>
        @if (isSuperAdmin) {
          <span aria-hidden="true">•</span>
          <!-- New tab, so the portal stays open behind it. -->
          <a routerLink="/whats-new" target="_blank" rel="noopener">What's New</a>
        }
        <app-version-info class="w-100 text-center"></app-version-info>
      </footer>
    </div>
  </div>

  <ng-template
    #moduleCard
    let-module
    let-q="q"
    let-title="title"
    let-desc="desc"
    let-links="links"
    let-external="external"
  >
    @let name = title ?? module.label;
    @let haystack = (name + ' ' + module.label + ' ' + desc + ' ' + links.join(' ')).toLowerCase();
    @if (!q || haystack.includes(q)) {
      <article
        class="wm-card position-relative d-flex flex-column justify-content-start h-100 border-0"
        [class.wm-card--external]="external"
      >
        <div class="wm-card__top d-flex align-items-start">
          <span class="wm-card__icon d-flex align-items-center justify-content-center flex-shrink-0"
            ><i class="bi" [ngClass]="module.icon"></i
          ></span>
          <div class="wm-card__text flex-fill pt-1">
            <h3 class="wm-card__title fw-500">
              <!-- stretched-link makes the whole card clickable without nesting anchors. -->
              <a [routerLink]="module.route" class="stretched-link text-decoration-none">{{ name }}</a>
            </h3>
            <p class="wm-card__desc m-0 overflow-hidden">{{ desc }}</p>
          </div>
          <div class="wm-card__corner flex-shrink-0 d-flex align-items-center">
            <label
              class="wm-fav position-relative z-2 d-flex align-items-center justify-content-center m-0 rounded-circle fs-16 cursor-pointer"
              [ngbTooltip]="isFavorite(module.route) ? 'Remove from favorites' : 'Add to favorites'"
              placement="top"
              (click)="toggleFavorite(module.route, $event)"
            >
              <input
                type="checkbox"
                class="visually-hidden"
                [checked]="isFavorite(module.route)"
                [attr.aria-label]="(isFavorite(module.route) ? 'Unfavorite ' : 'Favorite ') + name"
              />
              <i class="bi bi-star wm-fav__off"></i>
              <i class="bi bi-star-fill wm-fav__on"></i>
            </label>
            <!-- Up-right arrow on the CRM card: it opens a separate app. -->
            <i
              class="bi wm-card__arrow"
              [ngClass]="external ? 'bi-arrow-up-right' : 'bi-arrow-right'"
              aria-hidden="true"
            ></i>
          </div>
        </div>

        @if (external) {
          <div class="wm-card__actions position-relative z-2 d-flex flex-wrap">
            <a
              class="wm-card__open d-inline-flex align-items-center text-white text-decoration-none"
              [routerLink]="module.route"
            >
              Open {{ name }} <i class="bi bi-chevron-right"></i>
            </a>
          </div>
        } @else {
          <div class="wm-card__actions position-relative z-2 d-flex flex-wrap">
            @for (link of links; track link[0]) {
              <a
                class="wm-chip d-inline-flex align-items-center gap-2 text-decoration-none text-nowrap"
                [routerLink]="link[1] ?? module.route"
                [class.is-match]="q && link[0].toLowerCase().includes(q)"
              >
                {{ link[0] }} <i class="bi bi-chevron-right"></i>
              </a>
            }
          </div>
        }
      </article>
    }
  </ng-template>
</div>

<div class="chatbox position-fixed end-0 top-50">
  <app-chatbot></app-chatbot>
</div>
